<style lang="scss">
  @import "./styles/bootstrap-custom.scss";
  @import "~bootstrap-vue/dist/bootstrap-vue.css";
  @import "./styles/global.scss";
</style>

<template>
  <div class="container">
    <b-navbar toggleable="md" class="px-0">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

<!-- Question pool for small viewports -->

      <b-navbar-nav v-if="logged" class="ml-auto mr-2 d-md-none">
        <b-nav-text v-b-tooltip.hover :title="$t('global.menu.questionPool')">
          <b-badge variant="secondary" v-if="questionPool !== null">
            <font-awesome-icon icon="heart" class="heart-spinner" />
            {{questionPool}}
          </b-badge>
        </b-nav-text>
      </b-navbar-nav>

<!-- Brand logo -->

      <b-navbar-brand :to="{ name: 'PostList' }">
        <img src="./assets/favicon.svg" alt="DeepLOV" height="25">
        {{$t('global.menu.title')}}
      </b-navbar-brand>

<!-- Nav for small viewports -->

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item v-if="!logged" :to="{ name: 'AppAbout' }">
            <font-awesome-icon icon="info-circle"/>
            {{$t('global.menu.about')}}
          </b-nav-item>
          <b-nav-item v-if="!logged" :to="{ name: 'AppHelp' }">
            <font-awesome-icon icon="question-circle"/>
            {{$t('global.menu.help')}}
          </b-nav-item>
          <b-nav-item v-if="!logged" :to="{ name:'AppContactForm' }">
            <font-awesome-icon icon="envelope"/>
            {{$t('global.menu.contactForm')}}
          </b-nav-item>
          <b-nav-item v-if="logged" :to="{ name: 'QuestionShowCurrent' }">
            <font-awesome-icon icon="play"/>
            {{$t('global.menu.questions.continue')}}
          </b-nav-item>
          <b-nav-item v-if="logged" :to="{ name: 'UserAnswerList' }">
            <font-awesome-icon icon="chart-pie"/>
            <span class="d-md-none d-lg-inline">{{$t('global.menu.questions.myAnswers')}}</span>
            <span
              class="d-none d-md-inline d-lg-none"
            >{{$t('global.menu.questions.myAnswersResponsive')}}</span>
          </b-nav-item>
<!--          <b-nav-item v-if="logged" :to="{ name: 'MarketPlace' }">-->
<!--            <font-awesome-icon icon="shopping-cart"/>-->
<!--            <span class="d-md-none d-lg-inline">{{$t('global.menu.marketplace')}}</span>-->
<!--            <span class="d-none d-md-inline d-lg-none">{{$t('global.menu.marketplaceResponsive')}}</span>-->
<!--          </b-nav-item>-->
        </b-navbar-nav>

<!-- Right aligned content start -->

        <b-navbar-nav class="ml-auto">
          <b-nav-text
            v-if="logged"
            v-b-tooltip.hover
            :title="$t('global.menu.questionPool')"
            class="d-none d-md-inline"
          >
            <b-badge variant="secondary" v-if="questionPool !== null">
              <font-awesome-icon class="heart-spinner" :class="loading ? 'fa-spin' : ''" icon="heart"/>
              {{questionPool}}
            </b-badge>
          </b-nav-text>
          <b-nav-item
            v-if="!logged"
            @click="requireLogin"
            class="d-none d-md-block"
          >{{$t('global.menu.login')}}</b-nav-item>
          <b-nav-item
            v-if="!logged"
            :to="{ name: 'UserCreate' }"
            class="d-none d-md-block"
          >{{$t('global.menu.register')}}</b-nav-item>
          <b-nav-item-dropdown v-if="logged" right>
            <template slot="button-content">
              <font-awesome-icon icon="user"/>
              {{ userData.alias }}
            </template>
            <b-dropdown-item :to="{ name: 'UserUpdate' }" href="#">
              <font-awesome-icon icon="sliders-h"/>
              {{$t('global.menu.settings')}}
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ContactList' }">
              <font-awesome-icon icon="users"/>
              {{$t('global.menu.contacts')}}
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'PackList' }">
              <font-awesome-icon icon="cubes"/>
              {{$t('global.menu.questions.packs')}}
            </b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item :to="{ name: 'AppAbout' }">
              <font-awesome-icon icon="info-circle"/>
              {{$t('global.menu.about')}}
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'AppHelp' }">
              <font-awesome-icon icon="question-circle"/>
              {{$t('global.menu.help')}}
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'Tos'}">
              <font-awesome-icon icon="scroll"/>
              {{$t('global.menu.tos')}}
            </b-dropdown-item>
            <b-dropdown-item :to="{name:'AppContactForm'}">
              <font-awesome-icon icon="envelope"/>
              {{$t('global.menu.contactForm')}}
            </b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item @click="logout" href="#">
              <font-awesome-icon icon="sign-out-alt"/>
              {{$t('global.menu.logout')}}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

<!-- Right aligned content end -->

    <div class="text-center mb-4" v-if="!logged">
      <a class="d-md-none" @click="requireLogin" href="#">{{ $t('global.menu.login') }}</a>
      <router-link
        class="d-md-none ml-4"
        :to="{ name: 'UserCreate' }"
      >{{ $t('global.menu.register') }}</router-link>
    </div>
    <!-- Main Container start -->
    <div class="mt-3" id="main-container">
      <router-view v-on:giveAway="setGiveAway" :key="refreshToken"></router-view>
    </div>
    <login-modal/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import LoginModal from './components/user/LoginModal';


export default {
    data() {
        return {
            giveAwayShow: false
        };
    },
    components: {LoginModal},
    computed: mapGetters({
        logged: 'user/auth/logged',
        refreshToken: 'user/auth/refreshToken',
        userData: 'user/auth/userData',
        locale: 'user/auth/locale',
        questionPool: 'app/giveAway/questionPool',
        loading: 'loading/loading/loading'
    }),
    watch: {
        locale: function(val) {
            this.$i18n.locale = val;
        }
    },
    methods: {
        logout: function() {
            this.$router.push({name: 'PostList'});
            this.$store.dispatch('user/facebookAuth/logout');
            this.$store.dispatch('user/auth/logout').then(() => {
                for (let action in this.$store['_actions']) {
                    if (action.includes('reset')) {
                        this.$store.dispatch(action);
                    }
                }
            });
        },
        requireLogin: function() {
            this.$store.dispatch('user/auth/requireLogin');
        },
        setGiveAway: function() {
            this.$notify.success(this.$t('global.message.giveAway'));
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/App.vue